// extracted by mini-css-extract-plugin
export var errorsContainer = "_sk-1";
export var link = "_sk-0";